import { ChartConfig, TimeSeriesChartType } from "../template/time_series_data_chart";
import {
  DailyTimeSeriesChartProps,
  DailyTimeSeriesDataChart,
} from "../template/daily_time_series_chart";
import { GenericTimeSeriesDataChartConfig } from "../template/time_series_data_chart";
import { VisualizerGraphDataType } from "../../../shared/db";

export const TimeSeriesActigraphyChart = (props: DailyTimeSeriesChartProps) => {
  const { height, width, participantId, plotDataRange, commonTaskDataMarkerList } = props;

  const defaultDataTypeOption = {
    label: "Zero Crossing",
  };

  const subDataTypeOptions = [
    defaultDataTypeOption,
    {
      label: "Energy",
      value: "energy",
    },
  ];

  const dataConfig = {
    defaultDataTypeOption,
    subDataTypeOptions,
  };

  const chartConfig: ChartConfig = {
    chartType: TimeSeriesChartType.Area,
  };

  const chartCardConfig = {
    height,
    width,
    title: "Actigraphy",
    hintDescription: "",
  };

  const config: GenericTimeSeriesDataChartConfig = {
    dataConfig,
    chartConfig,
    chartCardConfig,
  };

  const timeSeriesChartProp = {
    dataType: VisualizerGraphDataType.GarminDirectActigraphyRaw,
    config,
    participantId,
    plotDataRange,
    commonTaskDataMarkerList,
  };

  return (
    <>
      <DailyTimeSeriesDataChart {...timeSeriesChartProp} />
    </>
  );
};
